import AddTag from "cruds/settings/tags/add-tag";
import AddNavBarItem from "cruds/settings/navbar/add-nav-item";
import EditUser from "cruds/user-management/edit-user";
import NewUser from "cruds/user-management/add-user";
import AddProject from "cruds/projects/add-project";
import AddSpecialProject from "cruds/special-projects/add-project";
import AddArticle from "cruds/articles/add-article";
import Pages from "cruds/landing-page/edit-landing-page";
import AddSliders from "cruds/website-management/sliders/add-slider";
import EditSliders from "cruds/website-management/sliders/edit-slider";
import AddContent from "cruds/website-management/settings/add-setting";
import EditContent from "cruds/website-management/settings/edit-setting";
import AddDonation from "cruds/donations/add-donation";
import EditDonation from "cruds/donations/edit-donation";
import Donations from "cruds/donations/donation-list";
import EditItems from "cruds/settings/items/add-item";
import EditFaq from "cruds/settings/faq/add-faq";
import EditReport from "cruds/settings/reports/add-report";

const crudRoutes = [
  {
    key: "add-project",
    route: "/projects/add/project",
    component: <AddProject />,
    type: "projects",
  },
  {
    key: "edit-project",
    route: "/projects/edit/project/:id",
    component: <AddProject />,
    type: "projects",
  },
  {
    key: "add-project",
    route: "/special/add/project",
    component: <AddSpecialProject />,
    type: "projects",
  },
  {
    key: "edit-project",
    route: "/special/edit/project/:id",
    component: <AddSpecialProject />,
    type: "projects",
  },
  {
    key: "add-new",
    route: "/news&bolgs/add/news",
    component: <AddArticle />,
    type: "news",
  },
  {
    key: "edit-new",
    route: "/news&bolgs/edit/news/:id",
    component: <AddArticle />,
    type: "news",
  },
  {
    key: "add-blog",
    route: "/news&bolgs/add/blogs",
    component: <AddArticle />,
    type: "blogs",
  },
  {
    key: "edit-blog",
    route: "/news&bolgs/edit/blogs/:id",
    component: <AddArticle />,
    type: "blogs",
  },
  {
    key: "edit-page",
    route: "/websiteManagement/edit/page/:id",
    component: <Pages />,
    type: "pages",
  },
  {
    key: "add-status",
    route: "/settings/add/project_status",
    component: <EditItems />,
    type: "project_status",
  },
  {
    key: "edit-status",
    route: "/settings/update/project_status/:id",
    component: <EditItems />,
    type: "project_status",
  },
  {
    key: "add-category",
    route: "/settings/add/categories",
    component: <EditItems />,
    type: "category",
  },
  {
    key: "edit-category",
    route: "/settings/update/categories/:id",
    component: <EditItems />,
    type: "category",
  },
  {
    key: "add-tag",
    route: "/settings/add/tags",
    component: <AddTag />,
    type: "tags",
  },
  {
    key: "edit-tag",
    route: "/settings/update/tags/:id",
    component: <AddTag />,
    type: "tags",
  },
  {
    key: "add-navbar-item",
    route: "/settings/add/navbar",
    component: <AddNavBarItem />,
    type: "navbar",
  },
  {
    key: "edit-navbar-item",
    route: "/settings/update/navbar/:id",
    component: <AddNavBarItem />,
    type: "navbar",
  },
  //
  {
    key: "add-faq",
    route: "/settings/add/faq",
    component: <EditFaq />,
    type: "faq",
  },
  {
    key: "edit-faq",
    route: "/settings/update/faq/:id",
    component: <EditFaq />,
    type: "faq",
  },
  {
    key: "add-report",
    route: "/settings/add/report",
    component: <EditReport />,
    type: "reports",
  },
  {
    key: "edit-report",
    route: "/settings/update/report/:id",
    component: <EditReport />,
    type: "reports",
  },
  //
  {
    key: "add-donation",
    route: "/donationManagement/donations/add",
    component: <AddDonation />,
    type: "donations",
  },
  {
    key: "edit-donation",
    route: "/donationManagement/donations/update/:id",
    component: <EditDonation />,
    type: "donations",
  },
  {
    key: "edit-donation",
    route: "/donationManagement/donations/filter/:filter",
    component: <Donations />,
    type: "donations",
  },
  {
    key: "edit-slider",
    route: "websiteManagement/slider/:id",
    component: <EditSliders />,
    type: "settings",
  },
  {
    key: "add-slider",
    route: "/websiteManagement/add/slider",
    component: <AddSliders />,
    type: "settings",
  },
  {
    key: "edit-content",
    route: "websiteManagement/content/:id",
    component: <EditContent />,
    type: "contents",
  },
  {
    key: "add-content",
    route: "/websiteManagement/add/content",
    component: <AddContent />,
    type: "contents",
  },
  {
    key: "add-countries",
    route: "/settings/add/countries",
    component: <EditItems />,
    type: "countries",
  },
  {
    key: "edit-countries",
    route: "/settings/update/countries/:id",
    component: <EditItems />,
    type: "countries",
  },
  {
    key: "add-authors",
    route: "/settings/add/authors",
    component: <EditItems />,
    type: "authors",
  },
  {
    key: "edit-authors",
    route: "/settings/update/authors/:id",
    component: <EditItems />,
    type: "authors",
  },
  {
    key: "add-target_segment",
    route: "/settings/add/target_segment",
    component: <EditItems />,
    type: "target_segment",
  },
  {
    key: "edit-target_segment",
    route: "/settings/update/target_segment/:id",
    component: <EditItems />,
    type: "target_segment",
  },
  {
    key: "add-user",
    route: "/userManagement/addUser/:route",
    component: <NewUser />,
    type: "users",
  },
  {
    key: "edit-user",
    route: "/userManagement/updateUser/:route/:id",
    component: <EditUser />,
    type: "users",
  },
];

export default crudRoutes;
